module.exports = __webpack_public_path__ + "media/images/flags/NL-1d21a97a0d59e90caa982f14285760f8.svg";